import type { Props } from './Svg'
import { Svg } from './Svg'

export function WarningIcon(props: Props) {
  return (
    <Svg width="56" height="54" stroke="none" fill="currentColor" {...props}>
      <path d="M30 36h-4V16h4v20Zm0 4h-4v4h4v-4Zm25.2 11.4c1-1.6 1-3.7.2-5.3L32.8 2.9A5.4 5.4 0 0 0 23 3L.6 46.1A5.4 5.4 0 0 0 5.4 54h45.1c2 0 3.7-1 4.7-2.6Zm-26-46.6 22.6 43.1a1.4 1.4 0 0 1-1.2 2.1H5.4a1.4 1.4 0 0 1-1.3-2.1L26.7 4.8c.3-.5.7-.8 1.3-.8.5 0 1 .3 1.3.8Z" />
    </Svg>
  )
}
